import { useAppModal, } from "../../components/features/Modals";
import { useNavigate, } from "react-router-dom";
import { useEffect, useRef, } from "react";
import { useEffectOnce, } from "../../utils/hooks";
import { QrPaymentModal, } from "../../components/features/Modals/QrPaymentModal";
import { useQRStore, } from "../../store/qrStore.ts";

export function QrPaymentPage() {
  const { showModal, isModalOpen, hideModal, } = useAppModal();
  const navigate = useNavigate();
  const setQRPayload = useQRStore(state => state.setQRPayload,);
  // The page could be unmounted only by router.
  // In this case, only if user pressed the back button.
  // In this case, we should prevent back navigation by the navigate function in onClose handler.
  // This can't be done via state, because the state will be lost after the page is unmounted.
  const byUnmount = useRef(false,);

  useEffect(() => {
    showModal({
      onClose: () => {
        if (!byUnmount.current) {
          setQRPayload(null,);
          navigate("../..", { relative: "path", },);
        }
      },
      header: "Платеж",
      content: (onClose, block,) => {
        return <QrPaymentModal onClose={onClose} block={block} />;
      },
    },);
  }, [],);

  useEffectOnce(() => {
    return () => {
      byUnmount.current = true;
    };
  },);

  useEffect(() => {
    return () => {
      if (isModalOpen) {
        hideModal();
      }
    };
  }, [isModalOpen,],);

  return null;
}

QrPaymentPage.loader = () => null;
